angular.module("ainapp")
    .controller("salesVoucherTrashController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {


            $scope.PageName = "Sales Voucher Trash";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.loadKendo = function () {
                $scope.KendoGridSource = new kendo.data.DataSource({
                    transport: {
                        read: function (o) {


                            if ($scope.selectedVoucher.NameVal == "Sales Enquiry") {
                                MainService.DeletedSalesEnquiries(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Quotation") {
                                MainService.DeletedSalesQuotations(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Order") {
                                MainService.DeletedSalesOrders(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Delivery Note") {
                                MainService.DeletedDeliveryNotes(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Packing List") {
                                MainService.DeletedPackingLists(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Invoice") {
                                MainService.DeletedSalesInvoices(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Direct Sales Invoice") {
                                MainService.DeletedDirSalesInvoices(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Individual Sales Invoice") {
                                MainService.DeletedIndSalesInvoices(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Export Sales Invoice") {
                                MainService.DeletedExpSalesInvoices(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Proforma Invoice") {
                                MainService.DeletedProSalesInvoices(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Return") {
                                MainService.DeletedSalesReturns(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Credit Note SR") {
                                MainService.DeletedCreditNoteSRs(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else {
                                o.success({
                                    Data: [],
                                    Total: 0
                                });
                            }


                        }
                    },
                    change: function (data) {},
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                Date: {
                                    type: "date",
                                },
                                CreatedDate: {
                                    type: "date",
                                },
                                UpdatedDate: {
                                    type: "date",
                                },
                                VoucherNumber: {
                                    type: "string",
                                },
                                GrandTotal: {
                                    type: "number",
                                },
                                NetTotal: {
                                    type: "number",
                                },
                                TotalTax: {
                                    type: "number",
                                },
                                "Customer.Name": {
                                    type: "string",
                                },
                                "CreatedBy.UserName": {
                                    type: "string",
                                },
                                "UpdatedBy.UserName": {
                                    type: "string",
                                },
                            }
                        }
                    },
                    pageSize: 30,
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                });

                $scope.KendoGridOptions = {
                    toolbar: ["excel"],
                    stretch: true,
                    selectable: true,
                    groupable: false,
                    height: 650,
                    sortable: true,
                    resizable: true,
                    dataSource: $scope.KendoGridSource,
                    pageable: true,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    filterable: true,

                    columns: [
                        {
                            field: "VoucherNumber",
                            title: "#",
                            width: "100px"
                    },
                        {
                            field: "Date",
                            template: "<p> {{dataItem.Date | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Date",
                            width: "100px"
                    },
                        {
                            field: "Customer.Name",
                            title: "Customer",
                            width: "200px"
                    },
                        {
                            field: "NetTotal",
                            title: "Net Total",
                            width: "100px"
                    }, {
                            field: "TotalTax",
                            title: "Total Tax",
                            width: "100px"
                    }, {
                            field: "GrandTotal",
                            title: "Grand Total",
                            width: "100px"
                    },
                        {
                            field: "CreatedBy.UserName",
                            title: "Created By",
                            width: "100px"
                    },
                        {
                            field: "CreatedDate",
                            template: "<p> {{dataItem.CreatedDate | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Created Date",
                            width: "100px"
                    },
                        {
                            field: "UpdatedBy.UserName",
                            title: "Updated By",
                            width: "100px"
                    },
                        {
                            field: "UpdatedDate",
                            template: "<p> {{dataItem.UpdatedDate | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Updated Date",
                            width: "100px"
                    },

                  ],
                };


            }


            $scope.Init = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.VArray = [];

                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;

                    var temp13 = {
                        Id: 13,
                        Name: "Sales Enquiry",
                        NameVal: "Sales Enquiry"
                    };
                    if ($scope.CompanyProfile.SalesEnquiry != "" & $scope.CompanyProfile.SalesEnquiry != null) {
                        temp13.Name = $scope.CompanyProfile.SalesEnquiry;
                    }
                    $scope.VArray.push(temp13);

                    var temp17 = {
                        Id: 17,
                        Name: "Sales Quotation",
                        NameVal: "Sales Quotation"
                    };
                    if ($scope.CompanyProfile.SalesQuotation != "" & $scope.CompanyProfile.SalesQuotation != null) {
                        temp17.Name = $scope.CompanyProfile.SalesQuotation;
                    }
                    $scope.VArray.push(temp17);

                    var temp21 = {
                        Id: 21,
                        Name: "Sales Order",
                        NameVal: "Sales Order"
                    };
                    if ($scope.CompanyProfile.SalesOrder != "" & $scope.CompanyProfile.SalesOrder != null) {
                        temp21.Name = $scope.CompanyProfile.SalesOrder;
                    }
                    $scope.VArray.push(temp21);

                    var temp25 = {
                        Id: 25,
                        Name: "Delivery Note",
                        NameVal: "Delivery Note"
                    };
                    if ($scope.CompanyProfile.DeliveryNote != "" & $scope.CompanyProfile.DeliveryNote != null) {
                        temp25.Name = $scope.CompanyProfile.DeliveryNote;
                    }
                    $scope.VArray.push(temp25);

                    var temp29 = {
                        Id: 29,
                        Name: "Packing List",
                        NameVal: "Packing List"
                    };
                    if ($scope.CompanyProfile.PackingList != "" & $scope.CompanyProfile.PackingList != null) {
                        temp29.Name = $scope.CompanyProfile.PackingList;
                    }
                    $scope.VArray.push(temp29);

                    var temp30 = {
                        Id: 30,
                        Name: "Sales Invoice",
                        NameVal: "Sales Invoice"
                    };
                    if ($scope.CompanyProfile.SalesInvoice != "" & $scope.CompanyProfile.SalesInvoice != null) {
                        temp30.Name = $scope.CompanyProfile.SalesInvoice;
                    }
                    $scope.VArray.push(temp30);

                    var temp34 = {
                        Id: 34,
                        Name: "Direct Sales Invoice",
                        NameVal: "Direct Sales Invoice"
                    };
                    if ($scope.CompanyProfile.DirSalesInvoice != "" & $scope.CompanyProfile.DirSalesInvoice != null) {
                        temp34.Name = $scope.CompanyProfile.DirSalesInvoice;
                    }
                    $scope.VArray.push(temp34);

                    var temp35 = {
                        Id: 35,
                        Name: "Individual Sales Invoice",
                        NameVal: "Individual Sales Invoice"
                    };
                    if ($scope.CompanyProfile.IndSalesInvoice != "" & $scope.CompanyProfile.IndSalesInvoice != null) {
                        temp35.Name = $scope.CompanyProfile.IndSalesInvoice;
                    }
                    $scope.VArray.push(temp35);

                    var temp36 = {
                        Id: 36,
                        Name: "Export Sales Invoice",
                        NameVal: "Export Sales Invoice"
                    };
                    if ($scope.CompanyProfile.ExpSalesInvoice != "" & $scope.CompanyProfile.ExpSalesInvoice != null) {
                        temp36.Name = $scope.CompanyProfile.ExpSalesInvoice;
                    }
                    $scope.VArray.push(temp36);

                    var temp37 = {
                        Id: 37,
                        Name: "Proforma Invoice",
                        NameVal: "Proforma Invoice"
                    };
                    if ($scope.CompanyProfile.ProformaInvoice != "" & $scope.CompanyProfile.ProformaInvoice != null) {
                        temp37.Name = $scope.CompanyProfile.ProformaInvoice;
                    }
                    $scope.VArray.push(temp37);

                    var temp38 = {
                        Id: 38,
                        Name: "Sales Return",
                        NameVal: "Sales Return"
                    };
                    if ($scope.CompanyProfile.SalesReturn != "" & $scope.CompanyProfile.SalesReturn != null) {
                        temp38.Name = $scope.CompanyProfile.SalesReturn;
                    }
                    $scope.VArray.push(temp38);

                    var temp39 = {
                        Id: 39,
                        Name: "Credit Note SR",
                        NameVal: "Credit Note SR"
                    };
                    if ($scope.CompanyProfile.CreditNoteSR != "" & $scope.CompanyProfile.CreditNoteSR != null) {
                        temp39.Name = $scope.CompanyProfile.CreditNoteSR;
                    }
                    $scope.VArray.push(temp39);

                    $scope.selectedVoucher = $scope.VArray[0];
                    $scope.loadKendo();
                    $.LoadingOverlay("hide");

                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }
            $scope.Init();


            $scope.refresh = function () {
                $scope.selectedVoucher = $scope.VArray[0];
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.changeView = function (data) {
                $scope.selectedVoucher = data;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.SearchKendo = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


                }])
